import React, { useState } from "react";
import { FormControlLabel, Button, Checkbox } from "@material-ui/core";
import useBDocTranslator from "../hooks/useBDocTranslator";
import ConsultationNotesEditor from "./ConsultationNotesEditor";

export default function ConsultationNotesEHR(props) {
  let btnStatus = props.enabledSaveConsultationBtn;
  const [checked, setChecked] = useState(true);
  const { t } = useBDocTranslator();

  const handleChange = (event) => {
    setChecked(event.target.checked);
    props.handleVisibility(!checked);
  };
  return (
    <div className="shadow p-3 m-2 bg-white rounded-lg col-md-12 col-sm-12 position-relative prescription-card">
      <ConsultationNotesEditor
        value={props.consultationNotesValue}
        onChange={(val) =>
          props.handleConsultationNotes({ target: { value: val } })
        }
        placeholder={t(
          "Consultation Notes Here, click to Pen button if you want minimize this section (the text entered will not be lost)"
        )}
        textareaClassName="mb-3 w-100 h-60-custom form-control col-md-12"
      />
      <div className="row col-sm-12">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            props.handleSaveConsultationNotes();
            props.handleRefreshData();
          }}
          className="col-md-6"
          // disabled={!btnStatus}
        >
          {t("Save")}
        </Button>
        <div className="pl-3">
          <FormControlLabel
            control={<Checkbox checked={checked} onChange={handleChange} />}
            label={t("Note visible")}
          />
        </div>
      </div>
      <div className="col-sm-12 col-md-12 mt-1 text-center">
        <p className="font-weight-bold">{props.responseCNMessage}</p>
      </div>
    </div>
  );
}
